import { render, staticRenderFns } from "./FilesAppSettingsGeneral.vue?vue&type=template&id=28f7c424"
import script from "./FilesAppSettingsGeneral.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilesAppSettingsGeneral.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports